// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__gX4c5","navTab":"styles_navTab__-va8E"};